import React from 'react';
import { Box, Typography, Avatar, Grid } from '@mui/material';
import doctorImage from '../../data/about/m-treat-doctor.jpg';
import pascalAvatar from '../../data/about/pascal-oduor.png';
import jaysonAvatar from '../../data/about/jayson-bakonyi.jpeg';
import missionImage from '../../data/about/mission.jpg';
import servicesImage from '../../data/about/services.jpg';

function About () {
  return (
    <Box
      sx={{
			  width: '100%',
			  margin: '0 auto',
			  backgroundColor: 'white',
			  color: 'black'
      }}
    >
      {/* Image Banner */}
      <Box
        component='img'
        src={doctorImage}
        alt='About M-TREAT - Your Trusted Healthcare Partner'
        sx={{
				  maxHeight: '20vh',
				  width: '100%',
				  height: { xs: '12vh', sm: '15vh', md: '20vh' },
				  objectFit: 'cover'
        }}
      />

      {/* About Us Section */}
      <Typography
        variant='h2'
        mb={2}
        sx={{
				  textAlign: 'center',
				  fontSize: { xs: '1.4rem', sm: '1.6rem', md: '2rem' }
        }}
      >
        ABOUT M-TREAT
      </Typography>

      <Box
        sx={{
				  maxWidth: { xs: '95%', sm: '90%', md: '60%' },
				  margin: '0 auto',
				  padding: '1rem',
				  borderTop: '1px solid #ddd'
        }}
      >
        {/* Mission Section */}
        <Grid container spacing={2} alignItems='center' mb={3}>
          <Grid item xs={12} md={6}>
            <Box
              component='img'
              src={missionImage}
              alt='Our Mission'
              sx={{ width: '100%', borderRadius: '8px' }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant='h4'
              fontWeight='bold'
              mb={2}
              sx={{ fontSize: { xs: '1rem', sm: '1.4rem', md: '1.6rem' } }}
            >
              Our Mission
            </Typography>
            <Typography
              variant='body1'
              sx={{ fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem' } }}
            >
              At <strong>M-TREAT</strong>, we are committed to improving
              healthcare access by connecting patients with the right medical
              professionals, providing personalized healthcare resources, and
              ensuring timely delivery of medications. We envision a healthier
              Africa, where everyone has the tools and support to live their
              best lives.
            </Typography>
          </Grid>
        </Grid>

        {/* Meet Our Team Section */}
        <Typography
          variant='h4'
          fontWeight='bold'
          mb={2}
          sx={{
					  textAlign: 'center',
					  fontSize: { xs: '1rem', sm: '1.4rem', md: '1.6rem' }
          }}
        >
          Meet Our Team
        </Typography>
        <Typography
          variant='body1'
          mb={3}
          sx={{
					  textAlign: 'center',
					  fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem' }
          }}
        >
          Our team consists of passionate healthcare professionals, tech
          innovators, and dedicated experts who believe in the power of
          accessible healthcare. Together, we work towards building a platform
          that bridges the gap between patients, doctors, hospitals, and
          pharmacies.
        </Typography>
        {/* </Grid> */}

        {/* Our Services Section */}
        <Grid container spacing={2} alignItems='center' mt={4}>
          <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
            <Typography
              variant='h4'
              fontWeight='bold'
              mb={2}
              sx={{ fontSize: { xs: '1rem', sm: '1.4rem', md: '1.6rem' } }}
            >
              Our Services
            </Typography>
            <Typography
              variant='body1'
              sx={{ fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem' } }}
            >
              <strong>M-TREAT</strong> offers a variety of services, including
              online pharmacy solutions, access to healthcare professionals, and
              reliable delivery of medications. We also provide health education
              resources and disease outbreak warnings, all through an
              easy-to-use digital platform.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
            <Box
              component='img'
              src={servicesImage}
              alt='Our Services'
              sx={{ width: '100%', borderRadius: '8px' }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default About;
